import ResponsiveListbox from './ResponsiveListboxContainer';

export default ResponsiveListbox;
